import mock from './mock';

const groups = {
  getAllGroups: {
    desc: '获取lp management groups列表',
    method: 'get',
    url: 'api/v1/users/groups',
    mock: false,
    request: { page: 1, page_size: 100, key: '' },
    response: mock.getAllGroups,
  },
  createGroup: {
    desc: 'lp management 新增 group',
    method: 'post',
    url: 'api/v1/users/group',
    mock: false,
    request: { group_name: '' },
    response: mock.createFolder,
  },
  updateGroupName: {
    desc: '修改lp management分组group名称',
    method: 'put',
    url: 'api/v1/users/group/{group_id}',
    mock: false,
    request: { group_name: '' },
    response: mock.createFolder,
  },
  deleteGroup: {
    desc: 'lp management分组列表删除 Group',
    method: 'delete',
    url: 'api/v1/users/group/{group_id}',
    mock: false,
    request: {},
    response: mock.createFolder,
  },
  deleteGroupUserAccount: {
    desc: 'lp management分组列表删除Group中的user account',
    method: 'post',
    url: 'api/v1/users/group_unbinding',
    mock: false,
    request: {
      group_id: '',
      user_id: '',
    },
    response: mock.createFolder,
  },
  addGroupUser: {
    desc: '新增Group中的用户',
    method: 'post',
    url: 'api/v1/users/group_binding',
    mock: false,
    request: {
      user_ids: '',
      group_id: '',
    },
    response: mock.createFolder,
  },
};

export default groups;
